import React, { useState, useEffect }from 'react'
import db from '../../firebase';

const query = db.collection('users').limit(100);

const Userslist = ({ user = null }) => {
    const [users, setusers] = useState([]);
    useEffect(() => {
        // Subscribe to query with onSnapshot
        const unsubscribe = query.onSnapshot(querySnapshot => {
          // Get all documents from collection - with IDs
          const data = querySnapshot.docs.map(doc => ({
            ...doc.data(),
            id: doc.id,
          }));
          // Update state
          setusers(data);
        });
      
        // Detach listener
        return unsubscribe;
      }, []);
    return (
        <div >
        <h2 className="w-full text-center font-bold text-xl">All User List</h2>
        <ul>
            {users.map(user=> (

                <li key={user.id} className="border-b-2 p-2">
                    <div className="inline-block">
                        <img src={user.photo} alt={user.name} className="w-8 h-8 rounded-full mr-4 inline-block" />
                    </div>
                    <div className="inline-block">
                        <p className="text-xl">{user.name}</p>
                    </div>
                </li>
            ))}
        </ul>
    </div>
    );
  };

export default Userslist;


